import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { StatusBadge } from "components/EntityTable";
import { formatDate } from "utils/datetime";

// Compact, persistent website summary shown at the top of the detail page.
// The edit pencil opens the edit dialog; lifecycle actions (activate, delete,
// notifications) live on the Settings tab.
function WebsiteInfoCard({ website, onEdit }) {
  const infoRow = (icon, content) => (
    <MDBox display="flex" alignItems="center" gap={1}>
      <Icon fontSize="small" sx={{ color: "text.secondary" }}>
        {icon}
      </Icon>
      <MDTypography variant="button" fontWeight="regular" color="text">
        {content}
      </MDTypography>
    </MDBox>
  );

  return (
    <Card sx={{ p: 3, mb: 3 }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <MDBox display="flex" gap={2} flex={1} minWidth={0}>
          <Avatar sx={{ bgcolor: "info.main", width: 56, height: 56, fontWeight: "bold" }}>
            {website.name?.charAt(0)?.toUpperCase() || "?"}
          </Avatar>
          <MDBox flex={1} minWidth={0}>
            <MDBox display="flex" alignItems="center" gap={1.5} mb={1} flexWrap="wrap">
              <MDTypography variant="h5" fontWeight="bold">
                {website.name}
              </MDTypography>
              <StatusBadge active={website.active} />
            </MDBox>
            <MDBox display="flex" flexDirection="column" gap={0.75}>
              {infoRow(
                "language",
                <Link href={`https://${website.domain}`} target="_blank" rel="noreferrer">
                  {website.domain}
                </Link>
              )}
              {infoRow("event", `Created: ${formatDate(website.created_at)}`)}
              {infoRow("history", `Last Updated: ${formatDate(website.updated_at)}`)}
            </MDBox>
          </MDBox>
        </MDBox>

        <Tooltip title="Edit website">
          <IconButton size="small" onClick={onEdit} aria-label="Edit website">
            <Icon>edit</Icon>
          </IconButton>
        </Tooltip>
      </MDBox>
    </Card>
  );
}

WebsiteInfoCard.propTypes = {
  website: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default WebsiteInfoCard;
